import { createRef, RefObject, VideoHTMLAttributes } from "react";
import { create } from "zustand";

interface IPortableVideoState {
  videoRef: React.RefObject<HTMLVideoElement | null>;
  videoAttributes: VideoHTMLAttributes<HTMLVideoElement>;
  targetRef: React.RefObject<HTMLElement | null>;
  updateVideo: (value: VideoHTMLAttributes<HTMLVideoElement>) => void;
  portVideo: (
    target: RefObject<HTMLElement | null>,
    attributes?: VideoHTMLAttributes<HTMLVideoElement>
  ) => void;
}

export const usePortableVideoStore = create<IPortableVideoState>((set) => ({
  videoRef: createRef<HTMLVideoElement>(),
  targetRef: createRef<HTMLElement>(),
  videoAttributes: {},
  updateVideo: (value) => set(() => ({ videoAttributes: value })),
  portVideo: (target, attributes) =>
    set(() =>
      attributes
        ? { targetRef: target, videoAttributes: attributes }
        : { targetRef: target }
    ),
}));
